import { connect } from 'react-redux';
import ModalError from './ModalError';
import { modalErrorClose } from '../../store/actions/modalError';

const mapStateToProps = ({ modalErrorReducer }) => modalErrorReducer;
const mapDispatchToProps = { modalErrorClose };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalError);
